import React from "react";
import RichText from "../content/RichText";

export default function BulletText(props) {
  return (
    <div className="flex gap-[14px] my-[10px]">
      <div>
        <div className="h-[26px] w-[26px] rounded-full bg-lightGray" />
      </div>
      <div className="min-w-0">
        <RichText html={props.text} />
        {props.text2 && <RichText html={props.text2} />}
      </div>
    </div>
  );
}
